import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AndroidIcon(props: IconProps) {
    return <Icon {...props} iconKey={"android"}/>
}
